import React, { useState, useEffect } from 'react'
import { Carousel } from 'antd';

const CustomArrow = ({ currentSlide, slideCount, ...props }) => (
    <button {...props} />
);

const TextSlider = ({ slides }) => {

    // const [slideimages, setSlideimages] = useState('')

    // useEffect(() => {
    //     setSlideimages(slides.icon)
    // }, []);

    console.log(slides)
    return (
        <>
            <Carousel autoplay dots arrows prevArrow={<CustomArrow />} nextArrow={<CustomArrow />}>
                {slides.map((slide, index) => (
                    <div className='min-h-[140px]' key={index}>
                        <div className='flex flex-row gap-4 items-center'>
                            <div>
                                <img src={slide.icon} width={200} />
                                {/* <img src={require(`${slide.icon}`)} width={200} /> */}
                            </div>
                            <div className='flex flex-col'>
                                <p className='gradient-small text-left bottom15px'>{slide.heading}</p>
                                <p className='txt-small text-left'>{slide.body}</p>
                            </div>
                        </div>
                    </div>
                )
                )
                }
            </Carousel >
        </>
    )
}

export default TextSlider